import React from 'react';
import AsideLeft from './AppAdminComponents/AsideLeft';
import NavBarNotificationBar from './AppAdminComponents/NavBarNotificationBar';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Footer from '../components/Footer';

export default function Aplicativo() {
    return (
        <>
            <div className="wrapper">
                {/* Navbar */}
                <nav className="main-header navbar navbar-expand navbar-white navbar-light">
                    <NavBarNotificationBar />

                </nav>
                <AsideLeft option="aplicativo" />
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0 text-dark">Download Aplicativo</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                {/* Left col */}
                                <section className="col-lg-12 connectedSortable">
                                    {/* Custom tabs (Charts with tabs)*/}
                                    <div className="card">
                                        <div className="card-header">
                                            <div className="card-tools">
                                                
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-xs-12">
                                                    <div className="box box-default">                                                        
                                                        <div className="box-body">
                                                            Requisitos
                                                            <ul>
                                                                <li>Sistema Operacional	Android 6.0 ou superior;</li>
                                                                <li>Smartphone Com acesso a internet;</li>
                                                                <li>1Gb memória;</li>
                                                                <li>Min. 200Mb de espaço para download/Instalação do aplicativo;</li>
                                                                <li>Permissão para instalar aplicativos de fontes desconhecidas;</li>
                                                            </ul>
                                                            <a href="./hondix.apk" style={{fontSize:50}}><i className="fa fa-android" /></a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>

                            </div>
                        </div>
                    </section>
                </div>

                <Footer />
            </div>
        </>
    )
}
